
import { FaBars, FaSearch, FaCog } from "react-icons/fa";
import { AiOutlineReload } from 'react-icons/ai'
import { TbLayoutList } from 'react-icons/tb'
import { CgMenuGridO, CgProfile } from "react-icons/cg";
import {HiOutlineCog8Tooth} from 'react-icons/hi2'
const Navbar = () => {
  return (
    <div>
      <nav className="flex justify-between items-center px-3 h-20 border-gray-300 border">
        <div className="flex items-center gap-2">
          <FaBars className="text-[1.3rem] text-gray-500" />
          <a href="">
            <img
              src="https://www.gstatic.com/images/branding/product/1x/keep_2020q4_48dp.png"
              alt=""
            />
          </a>
        </div>
        <div className="md:flex items-center xl:w-6/12 lg:w-7/12 w-7/12 bg-[#F1F3F4] focus-within:bg-white focus-within:shadow-lg transition-all delay-100 ease-in-out   rounded-md hidden">
          <span className="hover:bg-gray-300 p-4 rounded-full ">
            <FaSearch className="text-gray-600 hover:z-20 " />
          </span>
          <input
            type="text"
            className="w-[90%] border-none outline-none bg-transparent pl-5 "
            placeholder="Search"
          />
        </div>
        <div className="flex  justify-between lg:w-2/12  ">
          <div className="flex gap-6">
            <AiOutlineReload className="text-[1.5rem] text-gray-500" />
            <TbLayoutList className="text-[1.5rem] text-gray-500" />
            <HiOutlineCog8Tooth className="text-[1.5rem] text-gray-500" />
          </div>
          <div className="flex gap-3">
            <CgMenuGridO className="text-[1.5rem] text-gray-500" />
            <CgProfile className="text-[1.5rem] text-gray-500" />
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar